<!-- VIEW PAGE FROM AUTH CLIENTS & NO AUTH CLIENTS -->
<div *ngIf="appid !== 'intercomsetup'">
	<app-helper-view-auth-clients [mobileClients]="true"></app-helper-view-auth-clients>
</div>
<div *ngIf="appid === 'intercomsetup'">
	<app-helper-view-guest-clients appid="intercomsetup"></app-helper-view-guest-clients>
</div>